import {Component, Input} from '@angular/core';

export type DateFormatType = 'mediumDate' | 'shortDate' | 'longDate' | 'fullDate' | 'dd.MM.yyyy';
export type DateTimeFormatType = 'shortTime' | 'mediumTime' | 'longTime' | 'fullTime' | 'HH:mm';


export interface EventDescription {

    venueName: string,

    venueCity: string,

    performanceDate: Date | string,

    url?: string
}

export class EventDescConfig {

    locationClass?: string[] | string;

    constructor() {
    }
}

@Component({
    selector: 'btx-event-description',
    templateUrl: './event-description.component.html',
    styleUrls: ['./event-description.component.scss'],
  standalone: false
})
export class EventDescriptionComponent {

    /**
     *
     */
    @Input() venueName?: string;
    /**
     *
     */
    @Input() venueCity?: string;
    /**
     * First performance date
     */
    @Input() startDate: Date | any;

    /**
     * Last performance date
     */
    @Input() endDate: Date | any;

    /**
     *Multi Date
     */
    @Input() multiDate: boolean = false;
    /**
     *
     */
    @Input('dateFormat') format: DateFormatType | string = 'dd.MM.yyyy';
    /**
     *
     */

    @Input() timeFormat: DateTimeFormatType | string = 'HH:mm';
    /**
     *
     */
    @Input() venueUrl?: string;

    @Input() liveEvent?: boolean;

    @Input() hideVenue?: boolean;

    @Input() hideSaleDate?: boolean;

    @Input() isFlexibleEvent: boolean = false;

    constructor() {
    }

    isHideVenue(){
      return this.hideVenue;
    }

    isHideSaleDate(){
      return this.hideSaleDate;
    }

    isSameDate(): boolean {
      if (!this.startDate || !this.endDate) {
        return true;
      }
      const s = new Date(this.startDate);
      const e = new Date(this.endDate);
      //s.setHours(0, 0, 0, 0);
      //e.setHours(0, 0, 0, 0);
      return s.getTime() === e.getTime();
    }

    get showDateRange(): boolean {
      return this.multiDate && !this.isSameDate();
    }
}
